export default {
  routerList: [

    {
      path: '/homePage',
      component: () => import('@/views/index/home/homePage.vue'),
      name: '主页',
      children: []
    },
    // {
    //   path: '/homePage',
    //   component: () => import('@/views/index/home/homePageOld.vue'),
    //   name: '主页旧版',
    //   children: []
    // },
    {
      path: '/newList',
      component: () => import('@/views/index/home/newList.vue'),
      name: '新闻列表',
      children: []
    },
    {
      path: '/newDetails',
      component: () => import('@/views/index/home/newDetails.vue'),
      name: '新闻详情',
      children: []
    },
    {
      path: '/search',
      component: () => import('@/views/index/home/search.vue'),
      name: '搜索',
      children: []
    },
    // {
    //   path: '/lettersVisits',
    //   component: () => import('@/views/index/home/lettersVisits.vue'),
    //   name: '信访',
    //   children: []
    // },
    {
      path: '/introduce',
      component: () => import('@/views/index/home/introduce.vue'),
      name: '部门简介',
      children: []
    },
    {
      path: '/rmyjzj',
      component: () => import('@/views/index/home/rmyjzj.vue'),
      name: '人民意见征集',
      children: []
    },
    {
      path: '/wxjz',
      component: () => import('@/views/index/home/wxjz.vue'),
      name: '微信矩阵',
      children: []
    },
    {
      path: '/xxxt',
      component: () => import('@/views/index/home/xxxt.vue'),
      name: '信息系统',
      children: []
    },
    {
      path: '/bmdtMore',
      component: () => import('@/views/index/home/bmdtMore.vue'),
      name: '部门动态更多',
      children: []
    }

  ]
}
